<template>
  <div>
    <el-dialog :title="form.isCreate ? '新增礼包' : '修改礼包'" center :visible="true" @close="onClose"
      :close-on-click-modal="false" :close-on-press-escape="false" width="710px">
      <el-form ref="form" :model="form" label-width="200px" size="mini">
        <el-form-item label="名称：" prop="name">
          <el-input v-model="form.name" style="width: 170px"></el-input>
        </el-form-item>
        <el-form-item label="仅可被同一玩家领取一次：" prop="name">
          <el-switch v-model="form.isOnlyRedeemOneTimes" active-color="#13ce66" @change="changeSwitch">
          </el-switch>
        </el-form-item>
        <el-form-item label="内含：">
          <el-radio v-model="form.type" label="item" @input="changeRadio">奖励</el-radio>
          <el-radio v-model="form.type" label="pay" @input="changeRadio">
            支付项
            <el-tooltip style="" effect="dark" placement="top">
              <div slot="content">
                如果内含支付项，则使用绑定了当前礼包的兑换码时，将相当于付费购买该支付项
              </div>
              <span style=""><i class="el-icon-question"></i></span>
            </el-tooltip>
          </el-radio>
        </el-form-item>
        <el-form-item v-if="form.type == 'pay'" label="支付项：">
          <attachment  v-for="item of attachmentsOfPay" :key="item.seq" :availableAttachments="availableAttachmentsOfPay"
            :notShowDelBtn="true" :notShowNumberInput="true" v-model="item.data" nameWidth="300px"
            @remove="removeAttachmentOfPay(item.seq)"></attachment>
        </el-form-item>

        <el-form-item v-if="form.type == 'item'" label="奖励：">
          <attachment v-for="item of attachments" :key="item.seq" :availableAttachments="availableAttachments"
            v-model="item.data" @remove="removeAttachment(item.seq)" nameWidth="300px"></attachment>
          <el-button @click="addNewAttachment()" class="el-icon-plus">添加</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");

import Attachment from "./Attachment.vue";

// 本弹窗名称
const DialogName = "EditRedeemCodeGiftDialog";

export default {
  data() {
    return {
      form: {
        isCreate: true,
        type: 'item',
        isOnlyRedeemOneTimes:false,
        id: "",
        name: "",
        availableRedeemTimes:0,
        props: [],
      },
      attachments: [],
      availableAttachments: [],
      attachmentSeq: 0,
      attachmentsOfPay: [],
      availableAttachmentsOfPay: [],
      attachmentSeqOfPay: 0,
    };
  },
  components: {
    Attachment,
  },

  async created() {
    let value = this.$dialogutil.getData(DialogName);

    this.form.isCreate = value.isCreate;

    if (!this.form.isCreate) {
      this.form.id = value.entry.id;
      this.form.name = value.entry.name;
      this.form.availableRedeemTimes = value.entry.availableRedeemTimes;
      this.form.props = value.entry.props;

      if(this.form.availableRedeemTimes == 1){
        this.form.isOnlyRedeemOneTimes = true
      }
    }

    await this.loadAvailableAttachments();
    await this.loadAvailableAttachmentsOfPay();
  },

  methods: {
    async changeSwitch(e){
      if(e){
        this.form.isOnlyRedeemOneTimes = true
        this.form.availableRedeemTimes = 1
      }else{
        this.form.isOnlyRedeemOneTimes = false
        this.form.availableRedeemTimes = 0
      }
    },
    async changeRadio(e) {
      for(let item of this.attachments){
        await this.removeAttachment(item.seq)
      }

      for(let item of this.attachmentsOfPay){
        await this.removeAttachmentOfPay(item.seq)
      }

      if (e == 'pay') {
        await this.addNewAttachmentOfPay();
      }
    },
    /**
     * 提交表单
     */
    submit() {
      this.form.name = this.form.name.trim();
      if (this.form.name.length == 0) {
        this.$message({
          message: "名称不能为空",
          type: "error",
        });
        return;
      }

      let props = [];
      // 支付项
      for (let e of this.attachmentsOfPay) {
        if (e.data.valuesOfNodes.length == 0) {
          this.$message({
            message: "请正确选择奖励",
            type: "error",
          });
          return;
        }

        let id = e.data.valuesOfNodes[1];
        let amount = e.data.number;
        if (amount == 0) {
          this.$message({
            message: "奖励数量不能为0",
            type: "error",
          });
          return;
        }
        props.push({
          id: id,
          amount: amount,
        });
      }

      // 非支付项
      for (let e of this.attachments) {
        if (e.data.valuesOfNodes.length == 0) {
          this.$message({
            message: "请正确选择奖励",
            type: "error",
          });
          return;
        }

        let id = e.data.valuesOfNodes[1];
        let amount = e.data.number;
        if (amount == 0) {
          this.$message({
            message: "奖励数量不能为0",
            type: "error",
          });
          return;
        }
        props.push({
          id: id,
          amount: amount,
        });
      }

      if (props.length == 0) {
        this.$message({
          message: "奖励不能为空",
          type: "error",
        });
        return;
      }

      this.form.props = props;

      if (this.form.isCreate) {
        this.add();
      } else {
        this.update();
      }
    },

    /**
     * 新增
     */
    async add() {
      try {
        // 弹确认框
        await this.$confirm(`确认新增礼包？`);

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/addRedeemCodeGift`,
            {
              name: this.form.name,
              props: this.form.props,
              availableRedeemTimes: this.form.availableRedeemTimes,
              
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        // 弹确认框
        await this.$confirm(`添加成功`, { showCancelButton: false });

        // 关闭当前对话框
        this.onClose();
      } catch (e) { }
    },

    /**
     * 修改
     */
    async update() {
      try {
        // 弹确认框
        await this.$confirm(`确认修改礼包？`);

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/updateRedeemCodeGift`,
            {
              id: this.form.id,
              name: this.form.name,
              availableRedeemTimes: this.form.availableRedeemTimes,
              props: this.form.props,
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose();
      } catch (e) { }
    },

    /**
     * 查询可用附件集合
     */
    async loadAvailableAttachments() {
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/getAppendixList`,
          {
            isShowPayItem: false,
          },
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      for (let category of resData.data.categories) {
        this.availableAttachments.push({
          label: category.name,
          value: category.name,
          children: (() => {
            let result = [];
            for (let e of category.entries) {
              result.push({
                label: e.name,
                value: e.id,
              });
              if (!this.form.isCreate) {
                for (let item of this.form.props) {
                  if (item.id == e.id) {
                    this.form.type = "item"
                    this.attachments.push({
                      seq: ++this.attachmentSeq,
                      data: {
                        valuesOfNodes: [category.name, e.id],
                        number: item.amount,
                      },
                    });
                  }
                }
              }
            }
            return result;
          })(),
        });
      }
    },

    /**
     * 增加一个附件
     */
    addNewAttachment() {
      this.attachments.push({
        seq: ++this.attachmentSeq,
        data: {
          valuesOfNodes: [],
          number: 1,
        },
      });
    },

    /**
     * 删除一个附件
     */
    removeAttachment(seq) {
      for (let i = 0; i < this.attachments.length; i++) {
        if (this.attachments[i].seq == seq) {
          this.attachments.splice(i, 1);
          break;
        }
      }
    },

    /**
     * 查询可用支付项集合
     */
    async loadAvailableAttachmentsOfPay() {
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/getAppendixList`,
          {
            isShowPayItem: true,
          },
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      for (let category of resData.data.categories) {
        if (category.name != "支付项") {
          continue;
        }
        this.availableAttachmentsOfPay.push({
          label: category.name,
          value: category.name,
          children: (() => {
            let result = [];
            for (let e of category.entries) {
              result.push({
                label: e.name,
                value: e.id,
              });
              if (!this.form.isCreate) {
                for (let item of this.form.props) {
                  if (item.id == e.id) {
                    this.form.type = "pay"
                    this.attachmentsOfPay.push({
                      seq: ++this.attachmentSeqOfPay,
                      data: {
                        valuesOfNodes: [category.name, e.id],
                        number: item.amount,
                      },
                    });
                  }
                }
              }
            }
            return result;
          })(),
        });
      }
    },

    /**
     * 增加一个附件
     */
    addNewAttachmentOfPay() {
      this.attachmentsOfPay.push({
        seq: ++this.attachmentSeqOfPay,
        data: {
          valuesOfNodes: [],
          number: 1,
        },
      });
    },

    /**
     * 删除一个附件
     */
    removeAttachmentOfPay(seq) {
      for (let i = 0; i < this.attachmentsOfPay.length; i++) {
        if (this.attachmentsOfPay[i].seq == seq) {
          this.attachmentsOfPay.splice(i, 1);
          break;
        }
      }
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
  },
};
</script>